import { render, staticRenderFns } from "./ModuleCredentialForm.vue?vue&type=template&id=bf7beafc&scoped=true"
import script from "./ModuleCredentialForm.vue?vue&type=script&lang=js"
export * from "./ModuleCredentialForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleCredentialForm.vue?vue&type=style&index=0&id=bf7beafc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7beafc",
  null
  
)

export default component.exports